import { z } from 'zod';
import { isoTimestamp, uuid } from './primitives.js';
/**
 * Sounds an admin uploads for critical alerts. The server converts every
 * upload into something iOS accepts as a notification sound, and the app
 * downloads them into `Library/Sounds`, where an APNs payload can name them.
 * The built-in default stays what it is; uploads only add choices.
 */
/** Apple plays its stock sound instead of anything 30 seconds or longer. */
export const SOUND_MAX_DURATION_MS = 29_500;
/** The raw upload, before conversion trims and downmixes it. */
export const SOUND_MAX_UPLOAD_BYTES = 20 * 1024 * 1024;
export const soundName = z.string().trim().min(1, 'Name fehlt').max(60);
export const sound = z.object({
    id: uuid,
    name: z.string(),
    /** Name in the APNs payload and in `Library/Sounds` on the device. */
    file_name: z.string(),
    duration_ms: z.number().int(),
    size_bytes: z.number().int(),
    /** Hex digest, also the download's ETag. A sound never changes its content. */
    sha256: z.string(),
    created_at: isoTimestamp,
    updated_at: isoTimestamp,
});
/** The request body is the audio file itself; its name travels in the query. */
export const createSoundQuery = z.object({ name: soundName });
export const updateSoundBody = z.object({ name: soundName });
//# sourceMappingURL=sounds.js.map